<template>
    <v-row no-gutters>
        <v-col cols="auto">
            <v-btn small text class="mx-0" :disabled="!count">{{count}}</v-btn>
        </v-col>
        <v-col cols="grow">
            <v-btn small text class="mx-0" :color="color" col="auto" :style="{opacity: count > 0 ? '100%' : '30%'}"> {{ name }} </v-btn>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: 'LessonAssignment',
    props: {
        count: Number,
        name: String,
        color: String
    }
};
</script>
